import React, { FunctionComponent } from 'react';
import { Text, Image, Stack } from '@chakra-ui/react';
import { images } from '../support/imageSupport';


export interface BtGroupParams {
    items: [Vehicle | NoVehicle | Weight | NoWeight | Person | NoPerson | Company | NoCompany | Customer| NoCustomer|null]
}

interface BtGroupProps {
    items: [Vehicle | NoVehicle | Weight | NoWeight | Person | NoPerson | Company | NoCompany | Customer| NoCustomer | null]

}

export type typeItem = 'person' | 'company' | 'vehicle' | 'weight' | 'noPerson' | 'noCompany' | 'noVehicle' | 'noWeight' | 'customer' | ' noCustomer'

export interface Person {
    type: 'person'
    icon: string
    firstName: string
    lastName: string
    street: string
    zipCode: string
    city: string
}

export interface NoPerson {
    type: 'noPerson'
    icon: string
    message: string
}

export interface Company {
    type: 'company'
    icon: string
    name: string
    street: string
    zipCode: string
    city: string
}

export interface NoCompany {
    type: 'noCompany'
    icon: string
    message: string
}

export interface Vehicle {
    type: 'vehicle'
    icon: string
    regno: string
    model: string
}

export interface NoVehicle {
    type: 'noVehicle'
    icon: string
    message: string
}

export interface Weight {
    type: 'weight'
    icon: string
    weight: string
}

export interface NoWeight {
    type: 'noWeight'
    icon: string
    message: string
}

export interface Customer {
    type: 'customer'
    icon: string
    number: string
    message: string
}

export interface NoCustomer {
    type: 'noCustomer'
    icon: string
    message: string
}


const BtGroup: FunctionComponent<BtGroupProps> = ({ items }) => {

    return (<>
        {items.map(item => {
            if (item?.type === 'person') {
                return <Stack w='full' spacing={5} direction={['row', 'row']} key={item?.type} p={5} alignItems='center'>
                    <Image src={images(item.icon)} alt={item.type} />
                    <Stack w='full' spacing={0}  >
                        <Text as='h4' fontSize='xl'>{item.firstName} {item.lastName}</Text>
                        <Text>{item.street} {item.zipCode} {item.city}</Text>
                    </Stack>

                </Stack>
            } else if (item?.type === 'company') {
                return <Stack w='full' spacing={5} direction={['row', 'row']} key={item?.type} p={5} alignItems='center'>
                    <Image src={images(item.icon)} alt={item.type} />
                    <Stack w='full' spacing={0}  >
                        <Text as='h4' fontSize='xl'>{item.name}</Text>
                        <Text>{item.street} {item.zipCode} {item.city}</Text>
                    </Stack>
                </Stack>
            } else if (item?.type === 'weight') {
                return <Stack w='full' spacing={5} direction={['row', 'row']} key={item?.type} p={5} alignItems='center'>

                    <Image src={images(item.icon)} alt={item.type} />
                    <Text as='h4' fontSize='xl'>{item.weight}</Text>

                </Stack>
            } else if (item?.type === 'vehicle') {
                return <Stack w='full' spacing={5} direction={['row', 'row']} key={item?.type} p={5} alignItems='center'>
                    <Image src={images(item.icon)} alt={item.type} />
                    <Stack w='full' spacing={0}  >
                    <Text as='h4' fontSize='xl'>{item.regno}</Text>
                        <Text>{item.model}</Text>
                    </Stack>
                </Stack>
            }else if (item?.type === 'customer') {
                return <Stack w='full' spacing={5} direction={['row', 'row']} key={item?.type} p={5} alignItems='center'>

                    <Image src={images(item.icon)} alt={item.type} />
                    <Stack w='full' spacing={0}  >
                    <Text as='h4' fontSize='xl'>{item.number}</Text>
                        <Text>{item.message}</Text>
                    </Stack>
                
                </Stack>
            } else if (item?.type === 'noPerson'
                || item?.type === 'noVehicle'
                || item?.type === 'noCompany'
                || item?.type === 'noWeight'
                || item?.type === 'noCustomer'
            ) {
                return <Stack w='full' spacing={5} direction={['row', 'row']} key={item?.type} p={5} alignItems='center'>
                    <Image src={images(item.icon)} alt={item.type} />
                    <Text>{item.message}</Text>
                </Stack>
            } else { return }
        })}
    </>
    )

}

export default BtGroup;